import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { fields } from "../../constants";
import { useAirlineIncentives, useAirportConsultancy } from "../../BusinessOppurtunities.hook";
import { decodeHTML } from "~/Utils/CommonUtils";
import { corporateHost } from "~/Utils";

export const AirportConsultancyNextPage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const { data: mainContentData, error, isLoading, isError, refetch: useRefetchMainContent } = useAirportConsultancy();
  const { data: mainContentDataById, isLoading: isLoadingCam, refetch: refetchMainContent } = useDocumentDetails(query?.get("id") || "");

  console.log("brandGuidelines", mainContentData);

  useEffect(()=>{
    useRefetchMainContent();
  },[])

  useEffect(()=>{
    if(query.get('id')){
      refetchMainContent();
    }
  },[query.get('id')])

//   useEffect(() => {
//     if (!query.get("activeTab")) {
//       if (hasRole(["SUPER_ADMIN"])) {
//         navigate(`/dedicated/corporate/media-centre?activeTab=brandingGuidelines`, {
//           replace: true,
//         });
//       }
//     }
//   }, []);

const AirportConsultancyConfig: FormConfig = {
    initialValues: {
        field_content_english_markup: decodeHTML( mainContentDataById?.payload ?
          JSON.parse(mainContentDataById?.payload?.field_content_english)?.data?.markup :
          mainContentData?.[0]?.field_content_english?.data?.markup || ""
        ),
        field_content_english_next_page_name: decodeHTML( mainContentDataById?.payload ?
          JSON.parse(mainContentDataById?.payload?.field_content_english)?.data?.nextPage?.name :
          mainContentData?.[0]?.field_content_english?.data?.nextPage?.name || ""
        ),
        field_content_english_next_page_link: decodeHTML( mainContentDataById?.payload ?
          JSON.parse(mainContentDataById?.payload?.field_content_english)?.data?.nextPage?.link : 
          mainContentData?.[0]?.field_content_english?.data?.nextPage?.link || ""
        ),
        field_content_ms_markup: decodeHTML( mainContentDataById?.payload ?
          JSON.parse(mainContentDataById?.payload?.field_content_malay)?.data?.markup :
          mainContentData?.[0]?.field_content_malay?.data?.markup || ""
        ),
        field_content_ms_next_page_name: decodeHTML( mainContentDataById?.payload ?
          JSON.parse(mainContentDataById?.payload?.field_content_malay)?.data?.nextPage?.name :
          mainContentData?.[0]?.field_content_malay?.data?.nextPage?.name || ""
        ),
        field_content_ms_next_page_link: decodeHTML( mainContentDataById?.payload ?
          JSON.parse(mainContentDataById?.payload?.field_content_malay)?.data?.nextPage?.link : 
          mainContentData?.[0]?.field_content_malay?.data?.nextPage?.link || ""
        ),
        field_content_zh_markup: decodeHTML( mainContentDataById?.payload ?
          JSON.parse(mainContentDataById?.payload?.field_content_mandarin)?.data?.markup : 
          mainContentData?.[0]?.field_content_mandarin?.data?.markup || ""
        ),
        field_content_zh_next_page_name: decodeHTML( mainContentDataById?.payload ?
          JSON.parse(mainContentDataById?.payload?.field_content_mandarin)?.data?.nextPage?.name :
          mainContentData?.[0]?.field_content_mandarin?.data?.nextPage?.name || ""
        ),
        field_content_zh_next_page_link: decodeHTML( mainContentDataById?.payload ?
          JSON.parse(mainContentDataById?.payload?.field_content_mandarin)?.data?.nextPage?.link :
          mainContentData?.[0]?.field_content_mandarin?.data?.nextPage?.link || ""
        ),
    },      
    fields: fields.airportConsultancyNextPage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Business Opportunities",
      subModule: `${query?.get("activeTab")}_${query.get('subActiveTab')}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Business Opportunities_Airport Consultancy & Overseas Ventures",
      payload: {
        id: data?.id || mainContentData?.[0]?.id || mainContentDataById?.payload?.id,
        field_content_english: JSON.stringify({
          data: {
            items: [
                {
                    body: mainContentData?.[0]?.field_content_english?.data?.items?.[0]?.body || mainContentDataById?.payload?.field_content_english?.data?.items?.[0]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_english?.data?.items?.[0]?.tab?.name || mainContentDataById?.payload?.field_content_english?.data?.items?.[0]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_english?.data?.items?.[0]?.tab?.index || mainContentDataById?.payload?.field_content_english?.data?.items?.[0]?.tab?.index || ""
                    }
                },
                {
                    body: mainContentData?.[0]?.field_content_english?.data?.items?.[1]?.body || mainContentDataById?.payload?.field_content_english?.data?.items?.[1]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_english?.data?.items?.[1]?.tab?.name || mainContentDataById?.payload?.field_content_english?.data?.items?.[1]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_english?.data?.items?.[1]?.tab?.index || mainContentDataById?.payload?.field_content_english?.data?.items?.[1]?.tab?.index || ""
                    }
                },
                {
                    body: mainContentData?.[0]?.field_content_english?.data?.items?.[2]?.body || mainContentDataById?.payload?.field_content_english?.data?.items?.[2]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_english?.data?.items?.[2]?.tab?.name || mainContentDataById?.payload?.field_content_english?.data?.items?.[2]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_english?.data?.items?.[2]?.tab?.index || mainContentDataById?.payload?.field_content_english?.data?.items?.[2]?.tab?.index || ""
                    }
                },
                {
                    body: mainContentData?.[0]?.field_content_english?.data?.items?.[3]?.body || mainContentDataById?.payload?.field_content_english?.data?.items?.[3]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_english?.data?.items?.[3]?.tab?.name || mainContentDataById?.payload?.field_content_english?.data?.items?.[3]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_english?.data?.items?.[3]?.tab?.index || mainContentDataById?.payload?.field_content_english?.data?.items?.[3]?.tab?.index || ""
                    }
                }
            ],
            markup: data?.field_content_english_markup || "",
            nextPage: {
              name: data?.field_content_english_next_page_name || "",
              link: data?.field_content_english_next_page_link || "",
            },
          },
        }),
        field_content_malay: JSON.stringify({
          data: {
            items: [
                {
                    body: mainContentData?.[0]?.field_content_malay?.data?.items?.[0]?.body || mainContentDataById?.payload?.field_content_malay?.data?.items?.[0]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_malay?.data?.items?.[0]?.tab?.name || mainContentDataById?.payload?.field_content_malay?.data?.items?.[0]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_malay?.data?.items?.[0]?.tab?.index || mainContentDataById?.payload?.field_content_malay?.data?.items?.[0]?.tab?.index || ""
                    }
                },
                {
                    body: mainContentData?.[0]?.field_content_malay?.data?.items?.[1]?.body || mainContentDataById?.payload?.field_content_malay?.data?.items?.[1]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_malay?.data?.items?.[1]?.tab?.name || mainContentDataById?.payload?.field_content_malay?.data?.items?.[1]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_malay?.data?.items?.[1]?.tab?.index || mainContentDataById?.payload?.field_content_malay?.data?.items?.[1]?.tab?.index || ""
                    }
                },
                {
                    body: mainContentData?.[0]?.field_content_malay?.data?.items?.[2]?.body || mainContentDataById?.payload?.field_content_malay?.data?.items?.[2]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_malay?.data?.items?.[2]?.tab?.name || mainContentDataById?.payload?.field_content_malay?.data?.items?.[2]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_malay?.data?.items?.[2]?.tab?.index || mainContentDataById?.payload?.field_content_malay?.data?.items?.[2]?.tab?.index || ""
                    }
                },
                {
                    body: mainContentData?.[0]?.field_content_malay?.data?.items?.[3]?.body || mainContentDataById?.payload?.field_content_malay?.data?.items?.[3]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_malay?.data?.items?.[3]?.tab?.name || mainContentDataById?.payload?.field_content_malay?.data?.items?.[3]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_malay?.data?.items?.[3]?.tab?.index || mainContentDataById?.payload?.field_content_malay?.data?.items?.[3]?.tab?.index || ""
                    }
                }
            ],
            markup: data?.field_content_ms_markup || "",
            nextPage: {
              name: data?.field_content_ms_next_page_name || "",
              link: data?.field_content_ms_next_page_link || "",
            },
          },
        }),
        field_content_mandarin: JSON.stringify({
          data: {
            items: [
                {
                    body: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[0]?.body || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[0]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[0]?.tab?.name || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[0]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[0]?.tab?.index || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[0]?.tab?.index || ""
                    }
                },
                {
                    body: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[1]?.body || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[1]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[1]?.tab?.name || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[1]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[1]?.tab?.index || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[1]?.tab?.index || ""
                    }
                },
                {
                    body: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[2]?.body || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[2]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[2]?.tab?.name || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[2]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[2]?.tab?.index || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[2]?.tab?.index || ""
                    }
                },
                {
                    body: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[3]?.body || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[3]?.body || "",
                    tab:{
                        name: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[3]?.tab?.name || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[3]?.tab?.name || "",
                        index: mainContentData?.[0]?.field_content_mandarin?.data?.items?.[3]?.tab?.index || mainContentDataById?.payload?.field_content_mandarin?.data?.items?.[3]?.tab?.index || ""
                    }
                }
            ],
            markup: data?.field_content_zh_markup || "",
            nextPage: {
              name: data?.field_content_zh_next_page_name || "",
              link: data?.field_content_zh_next_page_link || "",
            },
          },
        }),
        field_page: mainContentData?.[0]?.field_page || mainContentDataById?.payload?.field_page  || "",
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };


  return (
    <>
      <DynamicForm
          isLoading={isLoading || isLoadingCam}
          config={AirportConsultancyConfig}
          onSubmit={(data, buttonValue, reviewNotes) =>
            onSubmit(
              data,
              `${corporateHost}/api/page-content/${mainContentData?.[0]?.id || mainContentDataById?.payload?.id || '94'}`,
              "UPDATE",
              "PATCH",
              buttonValue == "save" ? "DRAFT" : "PENDING",
              reviewNotes
            )
          }
          defaultReviewNotes="Kindly review this Business Opportunities"
        />
    </>
  );
};
